import * as React from 'react';
import { faShare as farShare } from '@fortawesome/pro-regular-svg-icons/faShare';
import { faShare as fasShare } from '@fortawesome/pro-solid-svg-icons/faShare';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ItemSaveContainer from '@/components/ItemSave/ItemSaveContainer';
import OverlayTrigger from '@/components/Overlay/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';
import { recordSocialNetworkShare } from '@/redux/modules/analytics';
import SocialIcons from '@/components/SocialIcons/SocialIcons';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

type Props = {
    itemId: number;
};

const ImageChildren = ({ itemId }: Props) => {
    const dispatch = useDispatch();

    const trackShare = React.useCallback(
        (network: string, itemUrl: string) => {
            dispatch(recordSocialNetworkShare(network, itemUrl));
        },
        [dispatch]
    );

    const popoverRight = (
        // TODO: switch this for new popovr component
        <Popover id="popover-positioned-right">
            <SocialIcons itemId={itemId} recordSocialNetworkShare={trackShare} />
        </Popover>
    );

    return (
        <>
            <StyledItemSaveContainer className="heart" itemId={itemId} />
            <OverlayTrigger
                delayHide={3000}
                overlay={popoverRight}
                placement="right"
                rootClose
                trigger={['hover', 'click']}
            >
                <StyledOuterIcon icon={farShare} />
            </OverlayTrigger>
            <StyledInnerIcon icon={fasShare} />
        </>
    );
};

export default React.memo<Props>(ImageChildren);

const StyledItemSaveContainer = styled(ItemSaveContainer).attrs(() => ({
    iconClassName: 'iconClassName',
}))`
    > div {
        width: auto;
        height: auto;
        position: absolute;
        right: 45px;
        top: 13px;
        z-index: 10;
    }
    .iconClassName {
        svg {
            width: 30px;
            height: 30px;
        }
    }
`;

const StyledInnerIcon = styled(FontAwesomeIcon)`
    bottom: 18px;
    color: ${({ theme }) => theme.colors.white};
    opacity: 0.65;
    position: absolute;
    z-index: 9;
    right: 22px;
    && {
        height: 34px;
        width: 27px;
    }
    &:hover {
        cursor: pointer;
    }
`;

const StyledOuterIcon = styled(FontAwesomeIcon)`
    color: ${({ theme }) => theme.colors.steel};
    position: absolute;
    z-index: 10;
    bottom: 19px;
    right: 21px;
    && {
        height: 35px;
        width: 30px;
    }
    &:hover {
        cursor: pointer;
        color: ${({ theme }) => theme.colors.blue300};
    }
`;
